import { useCallback, useRef } from 'react';

import { GenerationMode } from '@this+that/models';

export function useSingleFlowChoice() {
  const forceModeRef = useRef<GenerationMode | undefined>(undefined);

  const chooseSingleFlow = useCallback(() => {
    forceModeRef.current = GenerationMode.SINGLE_FLOW;
  }, []);

  const clearSingleFlowChoice = useCallback(() => {
    forceModeRef.current = undefined;
  }, []);

  const resolveForceMode = useCallback(
    (explicit?: GenerationMode) => explicit ?? forceModeRef.current,
    [],
  );

  return { chooseSingleFlow, clearSingleFlowChoice, resolveForceMode };
}
